export const ACCOUNT_TRANSACTIONS_RESET_STATE = 'ACCOUNT_TRANSACTIONS_RESET_STATE';
export const ACCOUNT_TRANSACTIONS_CURRENT_ITEM = 'ACCOUNT_TRANSACTIONS_CURRENT_ITEM';

export const ACCOUNT_TRANSACTIONS_REQUEST_LOADING = 'ACCOUNT_TRANSACTIONS_REQUEST_LOADING';
export const ACCOUNT_TRANSACTIONS_REQUEST_SUCCESS = 'ACCOUNT_TRANSACTIONS_REQUEST_SUCCESS';
export const ACCOUNT_TRANSACTIONS_REQUEST_FAILED = 'ACCOUNT_TRANSACTIONS_REQUEST_FAILED';

export const ACCOUNT_TRANSACTIONS_CURRENT_ACTION = 'ACCOUNT_TRANSACTIONS_CURRENT_ACTION';
export const ACCOUNT_TRANSACTIONS_RESET_ACTION = 'ACCOUNT_TRANSACTIONS_RESET_ACTION';